<template>
    <div>
        <div>
            <b-message type="is-info" has-icon v-if="pesquisas != null && pesquisas.length > 0">
                Para melhorar nossos serviços, pedimos a gentileza de responder a{{ pesquisas.length > 1 ? 's' : '' }} seguinte{{ pesquisas.length > 1 ? 's' : '' }} pesquisa{{ pesquisas.length > 1 ? 's' : '' }}:
                <p class="buttons">
                    <b-button v-for="(pesquisa, index) in pesquisas" :key="index" type="is-primary"
                              native-type="button"
                              @click="$router.push({ path: `/portal/pesquisassatisfacao/${pesquisa.id}` })">
                        {{pesquisa.nome}}
                    </b-button>
                </p>
            </b-message>
        </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex'

    export default {
        props: {
            pesquisas: Array,
            tipo: String
        },
        computed: {
            ...mapState([
                'config',
                'usuario'
            ])
        }
    }

</script>